export default {
  cookies: {
    is: 'Vefkökur',
    en: 'Cookies',
  },
  byClicking: {
    is: 'Með því að smella á “Leyfa allar” samþykkir þú notkun á vefkökum til þess að auka virkni vefsins, greina vefnotkun og aðstoða við markaðssetningu.',
    en: 'By clicking "Allow All", you agree to the use of cookies to enhance website functionality, analyse website usage and assist with marketing.',
  },

  allowAll: { is: 'Leyfa allar', en: 'Allow all' },

  moreOnCookies: {
    is: 'Nánar um vefkökur',
    en: 'More on cookies',
  },
  select: {
    is: 'Velja vefkökur',
    en: 'Select cookies',
  },
  essentialCookies: {
    is: 'Nauðsynlegar vefkökur',
    en: 'Essential cookies',
  },
  ensureWebsiteFunctionality: {
    is: 'Tryggja virkni vefsins',
    en: 'Ensure website functionality',
  },

  practicalCookies: {
    is: 'Hagnýtar vefkökur',
    en: 'Practical cookies',
  },

  practicalCookiesDetails: {
    is: 'Greina notkun svo við getum mælt og aukið gæði vefsins',
    en: 'Analyse usage so we can measure and enhance the quality of the website',
  },
  marketingCookies: {
    is: 'Vefkökur til markaðssetningar',
    en: 'Marketing cookies',
  },

  marketingCookiesDetails: {
    is: 'Notaðar til að birta persónubundnar auglýsingar',
    en: 'Used to display personalised ads',
  },

  cancel: {
    is: 'Hætta við',
    en: 'Cancel',
  },
  save: {
    is: 'Vista stillingar',
    en: 'Save settings',
  },
};
